import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, createVNode as _createVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "filters" }
const _hoisted_2 = { class: "searchButtons" }

import { ref } from 'vue';
import ExtendedSearch from '@intec/vue-components/search/ExtendedSearch.vue';
import { useApiEventsLogComponentStore } from '@/stores/apiEventsLogComponentStore.js';


export default /*@__PURE__*/_defineComponent({
  __name: 'Filters',
  props: {
  tableModel: {
    type: Object,
    required: true,
  },
},
  setup(__props) {



const searchParams = ref({});

const { getFilters } = useApiEventsLogComponentStore();
const filters = getFilters();

const search = () => {
  __props.tableModel.bind.options.page = 1;
  __props.tableModel.reload({searchParams});
}

const resetForm = () => {
  searchParams.value = {};
  __props.tableModel.reload();
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(filters), (filter, index) => {
      return (_openBlock(), _createBlock(_resolveDynamicComponent(filter), {
        key: index,
        searchParams: searchParams.value,
        "onUpdate:searchParams": _cache[0] || (_cache[0] = ($event: any) => ((searchParams).value = $event))
      }, null, 40 /* PROPS, NEED_HYDRATION */, ["searchParams"]))
    }), 128 /* KEYED_FRAGMENT */)),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(ExtendedSearch, {
        "table-model": __props.tableModel,
        "search-params": searchParams.value,
        onSearch: search,
        onResetSearch: resetForm
      }, null, 8 /* PROPS */, ["table-model", "search-params"])
    ])
  ]))
}
}

})